export default "__VITE_ASSET__CwpOABoW__"